<template>
  <v-col cols="12" md="3">
    <v-card :loading="loading" outlined class="mx-auto rounded-xl pa-4" height="150">
      <template slot="progress">
        <v-progress-linear color="indigo" indeterminate></v-progress-linear>
      </template>

      <div class="d-flex justify-space-between align-start">
        <span class="text-overline grey--text font-weight-bold">{{ label }}</span>
        <div
          class="d-flex align-center justify-center rounded-lg"
          :style="{ backgroundColor: corFundo, width: '38px', height: '38px' }"
        >
          <v-icon :color="cor" small>{{ icone }}</v-icon>
        </div>
      </div>

      <div class="text-h4 font-weight-black mt-2">{{ valor ?? 0 }}</div>
    </v-card>
  </v-col>
</template>

<script>
export default {
  name: "ResumoCard",
  props: {
    label: { type: String, required: true },
    valor: { type: Number, default: 0 },
    loading: { type: Boolean, default: false },
    icone: { type: String, default: "fa fa-list" },
    cor: { type: String, default: "primary" },
    corFundo: { type: String, default: "#e8f0fe" },
  },
};
</script>